import { confetti } from "@tsparticles/confetti";

/**
 * Launch a single realistic confetti fireworks burst
 * (Best for success or celebration triggers)
 */
export const launchFireworks = () => {
  const count = 200;
  const defaults = {
    origin: { y: 0.7 },
    colors: ['#004B50', '#00B8A9', '#FFD700', '#ffffff'],
    zIndex: 2000
  };

  function fire(particleRatio, opts) {
    confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio)
      })
    );
  }

  // 🎆 realistic layered explosion
  fire(0.25, {
    spread: 26,
    startVelocity: 55
  });

  fire(0.2, {
    spread: 60
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45
  });
};
